export default __webpack_public_path__ + "53942f266ded8f3896bd6b9b02f1e41c.png";